module.exports = __webpack_public_path__ + "static/media/ireland.6acfe50d.png";